export default "__VITE_ASSET__D1BQM3C8__"